import React, { useState } from 'react';
import { FormGroup, ModalBody, ModalHeader, Input, FormText } from 'reactstrap';
import './FeeVisibilityReasonModal.scss';
import Rodal from '../../../../components/Rodal/Rodal';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';

export interface FeeVisibilityReasonModalProps {
    isVisible: boolean;
    setIsVisible: (isVisible: boolean) => void;
    nextIsFeeDetailsVisible: boolean;
    onConfirm: (reason: string) => void;
    isSaving: boolean;
}

const FeeVisibilityReasonModal = (props: FeeVisibilityReasonModalProps) => {
    const [reason, setReason] = useState('');
    const [isReasonError, setIsReasonError] = useState(false);

    const handleConfirm = () => {
        if (!reason || reason.trim() === '') {
            setIsReasonError(true);
            return;
        }

        props.onConfirm(reason.trim());
    };

    return (
        <Rodal
            visible={props.isVisible}
            onClose={() => {
                props.setIsVisible(false);
            }}
            animation={'fade'}
            showMask={false}
            width={500}
            className="fee-visibility-reason-modal-rodal"
            center>
            <div className="fee-visibility-reason-modal">
                <ModalHeader>
                    {props.nextIsFeeDetailsVisible
                        ? 'Show Fee Details to Seller'
                        : 'Hide Fee Details from Seller'}
                </ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <label className="copy-name-label reason">Reason:</label>
                        <Input
                            type="textarea"
                            name="reason"
                            id="feeVisibilityReason"
                            rows={4}
                            value={reason}
                            onChange={(e: any) => {
                                setReason(e.target.value);
                                if (e.target.value.trim() !== '') {
                                    setIsReasonError(false);
                                }
                            }}
                            className={isReasonError ? 'av-invalid is-invalid' : ''}
                            placeholder="Enter reason for changing fee details visibility"
                        />
                        {isReasonError && (
                            <FormText color="danger" className="mt-1">
                                Reason is required
                            </FormText>
                        )}
                    </FormGroup>
                    <div className="mt-auto d-flex justify-content-end modal-copy-buttons">
                        <button
                            type="button"
                            className="btn btn-cancel"
                            onClick={() => {
                                props.setIsVisible(false);
                            }}>
                            Cancel
                        </button>
                        <ButtonLoader
                            buttonText={'Confirm'}
                            disabled={!reason || reason.trim() === ''}
                            isLoading={props.isSaving}
                            onClick={handleConfirm}
                            className={props.isSaving ? 'btn btn-primary loader-submit' : 'btn btn-primary'}
                            loaderButtonText={undefined}></ButtonLoader>
                    </div>
                </ModalBody>
            </div>
        </Rodal>
    );
};

export default FeeVisibilityReasonModal;
